import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import UserView from './UserView';
import AdminView from './AdminView';

const H8View = () => {
  const { user } = useAuth();

  return (
    <div>
      {/* Main content - AdminView or UserView based on role */}
      {user?.role === 'admin' ? (
        <AdminView engineType="H8" />
      ) : (
        <UserView engineType="H8" />
      )}
    </div>
  );
};

export default H8View;